<template>
  <el-dialog
      title="修改密码"
      :visible.sync="visible"
      width="420px"
      @close="resetForm"
  >
    <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="100px"
    >
      <el-form-item label="原密码" prop="oldPwd">
        <el-input v-model="form.oldPwd" type="password" show-password />
      </el-form-item>

      <el-form-item label="新密码" prop="newPwd">
        <el-input v-model="form.newPwd" type="password" show-password />
      </el-form-item>

      <el-form-item label="确认新密码" prop="confirmPassword">
        <el-input v-model="form.confirmPassword" type="password" show-password />
      </el-form-item>
    </el-form>

    <span slot="footer">
      <el-button @click="$emit('update:visible', false)">取消</el-button>
      <el-button type="primary" :loading="loading" @click="submit">
        确认修改
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { changePwd } from '@/api/auth'
import { mapState } from 'vuex'

export default {
  name: 'ChangePassword',
  props: {
    visible: Boolean
  },
  data() {
    const validateConfirm = (rule, value, cb) => {
      if (value !== this.form.newPwd) {
        cb(new Error('两次输入的密码不一致'))
      } else {
        cb()
      }
    }
    return {
      loading: false,
      form: {
        oldPwd: '',
        newPwd: '',
        confirmPassword: ''
      },
      rules: {
        oldPwd: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        newPwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码至少6位', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: validateConfirm, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.loading = true
        try {
          await changePwd({
            oldPwd: this.form.oldPwd,
            newPwd: this.form.newPwd
          })
          this.$message.success('密码修改成功，请重新登录')
          this.visible = false
          setTimeout(() => {
            this.$store.dispatch('logout')
            this.$router.push('/login')
          }, 800)
        } catch (e) {
          this.$message.error(e.message || '修改失败')
        } finally {
          this.loading = false
        }
      })
    },
    resetForm() {
      // this.$refs.form.resetFields()
      this.$emit('update:visible', false)
    }
  }
}
</script>